import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { AiChat } from './app/ai-chat';
import { Callback } from './app/auth/callback';
import { Logout } from './app/auth/logout';
import { Dashboard } from './app/dashboard';
import { ErrorPage } from './app/error';
import { Onboarding } from './app/onboarding';
import { Settings } from './app/settings';
import { userSelector } from './redux/user/selectors';
import type { RouteObject } from 'react-router-dom';

const Root = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector(userSelector);

  useEffect(() => {
    if (user && user.onboardingStatus === 'PENDING' && location.pathname !== '/onboarding') {
      navigate('/onboarding');
    }
    if (user && user.onboardingStatus === 'COMPLETED' && location.pathname === '/onboarding') {
      navigate('/');
    }
  }, [navigate, user, location.pathname]);

  return <Outlet />;
};

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Root />,
    children: [
      {
        path: '/',
        element: <Dashboard />,
      },
      {
        path: '/onboarding',
        element: <Onboarding />,
      },
      {
        path: '/callback',
        element: <Callback />,
      },
      {
        path: '/logout',
        element: <Logout />,
      },
      {
        path: '/settings',
        element: <Settings />,
      },
      {
        path: '/ai-chat',
        element: <AiChat />,
      },
      {
        path: '/error',
        element: <ErrorPage />,
      },
      {
        path: 'about',
        element: <div>About</div>,
      },
    ],
  },
];
